import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  header: {
    margin: theme.spacing(5, 0, 2, 0),
    fontSize: 24,
    fontWeight: 500,
    lineHeight: 1.25,
    color: theme.colorPalette.green_90
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
    padding: theme.spacing(6)
  }
}));

export default useStyles;
